module.exports = __webpack_public_path__ + "static/media/tooltip.ded395d8.svg";